import { render, staticRenderFns } from "./ProgramadorNuevaClase.vue?vue&type=template&id=41978a71&"
import script from "./ProgramadorNuevaClase.vue?vue&type=script&lang=js&"
export * from "./ProgramadorNuevaClase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports